export default __webpack_public_path__ + "static/media/slide5.850d88dc.jpg";